class wpcf_HeaderAppearance {
    constructor() {
        this.wpcf_wp = window.wp;

        if ( ! this.wpcf_isEditorAvailable() ) return;

        this.wpcf_init();
    }

    wpcf_isEditorAvailable() {
        return Boolean(
            this.wpcf_wp?.blockEditor &&
            this.wpcf_wp?.components &&
            this.wpcf_wp?.compose &&
            this.wpcf_wp?.coreData &&
            this.wpcf_wp?.data &&
            this.wpcf_wp?.editor &&
            this.wpcf_wp?.element &&
            this.wpcf_wp?.hooks &&
            this.wpcf_wp?.plugins
        );
    }

    wpcf_init() {
        const wpcf_wp = this.wpcf_wp;
        const wpcf_element = wpcf_wp.element.createElement;
        const wpcf_Fragment = wpcf_wp.element.Fragment;
        const wpcf_SelectControl = wpcf_wp.components.SelectControl;
        const wpcf_PanelBody = wpcf_wp.components.PanelBody;
        const wpcf_InspectorControls = wpcf_wp.blockEditor.InspectorControls;
        const wpcf_PluginDocumentSettingPanel = wpcf_wp.editor.PluginDocumentSettingPanel;
        const wpcf_createHigherOrderComponent = wpcf_wp.compose.createHigherOrderComponent;
        const wpcf_useEntityProp = wpcf_wp.coreData.useEntityProp;
        const wpcf_useSelect = wpcf_wp.data.useSelect;
        const wpcf_translate = wpcf_wp.i18n.__;
        const wpcf_solid_header_class = 'wpcf_is-solid-header';

        const wpcf_header_appearance_options = [
            {
                label: wpcf_translate( 'Default Header', 'content-theme-child' ),
                value: 'default',
            },
            {
                label: wpcf_translate( 'Solid Header', 'content-theme-child' ),
                value: 'solid',
            },
        ];

        function wpcf_PageHeaderAppearanceControl() {
            const [ wpcf_meta, wpcf_setMeta ] = wpcf_useEntityProp(
                'postType',
                'page',
                'meta'
            );
            const wpcf_value = wpcf_meta?.wpcf_header_appearance || 'default';

            return wpcf_element(
                wpcf_PluginDocumentSettingPanel,
                {
                    name: 'wpcf_header_appearance',
                    title: wpcf_translate( 'Header Appearance', 'content-theme-child' ),
                    className: 'wpcf_header-appearance-panel',
                },
                wpcf_element( wpcf_SelectControl, {
                    label: wpcf_translate( 'Header Style', 'content-theme-child' ),
                    value: wpcf_value,
                    options: wpcf_header_appearance_options,
                    __next40pxDefaultSize: true,
                    onChange: function ( wpcf_nextValue ) {
                        wpcf_setMeta( {
                            ...wpcf_meta,
                            wpcf_header_appearance: wpcf_nextValue,
                        } );
                    },
                    __nextHasNoMarginBottom: true,
                } )
            );
        }

        function wpcf_PageHeaderAppearancePanel() {
            const wpcf_postType = wpcf_useSelect( function ( wpcf_select ) {
                return wpcf_select( 'core/editor' ).getCurrentPostType();
            }, [] );

            if ( 'page' !== wpcf_postType ) return null;

            return wpcf_element( wpcf_PageHeaderAppearanceControl );
        }

        function wpcf_getTemplateHeaderAppearance( wpcf_className ) {
            const wpcf_classes = ( wpcf_className || '' ).split( /\s+/ ).filter( Boolean );
            return wpcf_classes.includes( wpcf_solid_header_class ) ? 'solid' : 'default';
        }

        function wpcf_setTemplateHeaderAppearance( wpcf_value, wpcf_props ) {
            const wpcf_classes = new Set(
                ( wpcf_props.attributes.className || '' ).split( /\s+/ ).filter( Boolean )
            );

            if ( 'solid' === wpcf_value ) {
                wpcf_classes.add( wpcf_solid_header_class );
            } else {
                wpcf_classes.delete( wpcf_solid_header_class );
            }

            wpcf_props.setAttributes( {
                className: Array.from( wpcf_classes ).join( ' ' ) || undefined,
            } );
        }

        const wpcf_withHeaderAppearanceControl = wpcf_createHigherOrderComponent(
            function ( wpcf_BlockEdit ) {
                return function ( wpcf_props ) {
                    const wpcf_isHeaderTemplatePart =
                        'core/template-part' === wpcf_props.name &&
                        'header' === wpcf_props.attributes.slug;

                    return wpcf_element(
                        wpcf_Fragment,
                        null,
                        wpcf_element( wpcf_BlockEdit, wpcf_props ),
                        wpcf_isHeaderTemplatePart && wpcf_props.isSelected
                            ? wpcf_element(
                                wpcf_InspectorControls,
                                { group: 'content' },
                                wpcf_element(
                                    wpcf_PanelBody,
                                    {
                                        title: wpcf_translate( 'Header Appearance', 'content-theme-child' ),
                                        initialOpen: true,
                                        className: 'wpcf_header-appearance-panel',
                                    },
                                    wpcf_element( wpcf_SelectControl, {
                                        label: wpcf_translate( 'Header Style', 'content-theme-child' ),
                                        value: wpcf_getTemplateHeaderAppearance(
                                            wpcf_props.attributes.className
                                        ),
                                        options: wpcf_header_appearance_options,
                                        __next40pxDefaultSize: true,
                                        onChange: function ( wpcf_nextValue ) {
                                            wpcf_setTemplateHeaderAppearance(
                                                wpcf_nextValue,
                                                wpcf_props
                                            );
                                        },
                                        __nextHasNoMarginBottom: true,
                                    } )
                                )
                            )
                            : null
                    );
                };
            },
            'wpcf_withHeaderAppearanceControl'
        );

        wpcf_wp.hooks.addFilter(
            'editor.BlockEdit',
            'wpcf_header_appearance/block-edit',
            wpcf_withHeaderAppearanceControl
        );

        // WordPress plugin slugs only allow lowercase letters, numbers, and dashes.
        wpcf_wp.plugins.registerPlugin( 'wpcf-header-appearance', {
            render: wpcf_PageHeaderAppearancePanel,
        } );
    }
}

export default wpcf_HeaderAppearance;
